export enum ContractEnum {
  Permanent = 1,
  Freelance = 2,
  Internship = 3
}
